import { render, staticRenderFns } from "./ConfirmDialogRoot.vue?vue&type=template&id=15d63a96"
import script from "./ConfirmDialogRoot.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialogRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports